import { HttpParams } from '@angular/common/http';
import { ApiService } from '@libs/core/base-config';
import { omitUndefinedValues } from '@libs/core/lib/utils/utils';
import {
  Dtos,
  adminVendorsListResponseSchema,
  vendorSchema,
  vendorsListByFilterResponseSchema,
  vendorsListForVendorsResponseSchema,
  vendorsListResponseSchema,
} from '@libs/mtjr/shared/generated/types';
import { map } from 'rxjs';

export function requestToPublishVendor(apiService: ApiService, { vendorId }: Dtos.RequestToPublishVendorPathParams) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/vendors/request-to-publish-vendor/${vendorId}`, {});
}

export function unPublishVendor(apiService: ApiService, { vendorId }: Dtos.UnPublishVendorPathParams) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/vendors/un-publish-vendor/${vendorId}`, {});
}

export function getVendorById(
  apiService: ApiService,
  queryParams: Dtos.GetVendorByIdQueryParams,
  { vendorId }: Dtos.GetVendorByIdPathParams,
) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/vendors/get-vendor-by-id/${vendorId}`, { params })
    .pipe(map((data) => vendorSchema().parse(data)));
}

export function vendorsList(apiService: ApiService, queryParams: Dtos.VendorsListQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/vendors/vendors-list`, { params })
    .pipe(map((data) => vendorsListResponseSchema().parse(data)));
}

export function vendorsListForVendors(apiService: ApiService, queryParams: Dtos.VendorsListForVendorsQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/vendors/vendors-list-for-vendors`, { params })
    .pipe(map((data) => vendorsListForVendorsResponseSchema().parse(data)));
}

export function adminVendorsList(apiService: ApiService, queryParams: Dtos.AdminVendorsListQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/vendors/admin-vendors-list`, { params })
    .pipe(map((data) => adminVendorsListResponseSchema().parse(data)));
}

export function adminVendorsDecision(apiService: ApiService, { decisionList }: Dtos.AdminVendorsDecisionList) {
  return apiService.http.post<void>(`${apiService.baseUrl}/api/v1/vendors/admin-vendors-decision`, { decisionList });
}

export function vendorsListByFilter(apiService: ApiService, queryParams: Dtos.VendorsListByFilterQueryParams) {
  const params = new HttpParams({ fromObject: omitUndefinedValues(queryParams) });
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/vendors/vendors-list-by-filter`, { params })
    .pipe(map((data) => vendorsListByFilterResponseSchema().parse(data)));
}

export function vendorCreate(
  apiService: ApiService,
  {
    deleted,
    name,
    addressLabel,
    addressStreet,
    addressInternal,
    addressPhone,
    addressPhone2,
    addressLat,
    addressLng,
    logo,
    background,
  }: Dtos.VendorCreateBody,
) {
  return apiService.http
    .post(`${apiService.baseUrl}/api/v1/vendors/vendor-create`, {
      deleted,
      name,
      addressLabel,
      addressStreet,
      addressInternal,
      addressPhone,
      addressPhone2,
      addressLat,
      addressLng,
      logo,
      background,
    })
    .pipe(map((data) => vendorSchema().parse(data)));
}

export function vendorDelete(apiService: ApiService, { vendorId }: Dtos.VendorDeletePathParams) {
  return apiService.http.delete<void>(`${apiService.baseUrl}/api/v1/vendors/vendor-delete/${vendorId}`, {});
}

export function vendorUpdate(
  apiService: ApiService,
  { vendor }: Dtos.VendorUpdateBody,
  { vendorId }: Dtos.VendorUpdatePathParams,
) {
  return apiService.http.put<void>(`${apiService.baseUrl}/api/v1/vendors/vendor-update/${vendorId}`, { vendor });
}
